import { QueryParamNames } from '~/constants/search';

export const getWorkspaceAgentChatIdFromLocation = (location: Pick<Location, 'search'>): string | null =>
  new URLSearchParams(location.search).get(QueryParamNames.chatId) || null;
